import { render, staticRenderFns } from "./CardEstrategiaCard.vue?vue&type=template&id=4fb2784f"
import script from "./CardEstrategiaCard.vue?vue&type=script&lang=js"
export * from "./CardEstrategiaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports